<div class="home-cuenta-juridica__steps-stage">
  <form
    class="home-cuenta-juridica home-cuenta-juridica--step-1 home-cuenta__form home-cuenta-juridica__step-pane home-cuenta-juridica__step-pane--1"
    [class.home-cuenta-juridica__step-pane--active]="pasoActual === 1"
    [formGroup]="step1Form"
    novalidate
  >
    <div class="home-cuenta-juridica__step-header">
      <span class="home-cuenta-juridica__step-badge">Paso 1:</span>
      <h3 class="home-cuenta-juridica__step-title">Datos personales</h3>
    </div>

    <div class="home-cuenta-juridica__form">
      <div class="home-cuenta-juridica__row">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('primerNombre')">
          <label class="home-cuenta__label" [for]="idPrefix + '-primer-nombre'">Primer nombre*</label>
          <input
            [id]="idPrefix + '-primer-nombre'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('primerNombre')"
            type="text"
            formControlName="primerNombre"
            placeholder="Escribe aquí"
            maxlength="20"
            autocomplete="given-name"
            appOnlyLetters
          />
          @if (isInvalidStep1('primerNombre')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('primerNombre') }}</div>
          }
        </div>
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('segundoNombre')">
          <label class="home-cuenta__label" [for]="idPrefix + '-segundo-nombre'">Segundo nombre</label>
          <input
            [id]="idPrefix + '-segundo-nombre'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('segundoNombre')"
            type="text"
            formControlName="segundoNombre"
            placeholder="Escribe aquí"
            maxlength="20"
            autocomplete="additional-name"
            appOnlyLetters
          />
          @if (isInvalidStep1('segundoNombre')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('segundoNombre') }}</div>
          }
        </div>
      </div>

      <div class="home-cuenta-juridica__row">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('primerApellido')">
          <label class="home-cuenta__label" [for]="idPrefix + '-primer-apellido'">Primer Apellido*</label>
          <input
            [id]="idPrefix + '-primer-apellido'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('primerApellido')"
            type="text"
            formControlName="primerApellido"
            placeholder="Escribe aquí"
            maxlength="20"
            autocomplete="family-name"
            appOnlyLetters
          />
          @if (isInvalidStep1('primerApellido')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('primerApellido') }}</div>
          }
        </div>
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('segundoApellido')">
          <label class="home-cuenta__label" [for]="idPrefix + '-segundo-apellido'">Segundo Apellido</label>
          <input
            [id]="idPrefix + '-segundo-apellido'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('segundoApellido')"
            type="text"
            formControlName="segundoApellido"
            placeholder="Escribe aquí"
            maxlength="20"
            appOnlyLetters
          />
          @if (isInvalidStep1('segundoApellido')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('segundoApellido') }}</div>
          }
        </div>
      </div>

      <div class="home-cuenta-juridica__row home-cuenta__row--stack-mobile">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('celular')">
          <label class="home-cuenta__label" [for]="idPrefix + '-celular'">Celular*</label>
          <input
            [id]="idPrefix + '-celular'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('celular')"
            type="tel"
            formControlName="celular"
            placeholder="Escribe aquí"
            maxlength="10"
            autocomplete="tel"
            appOnlyNumbers
          />
          @if (isInvalidStep1('celular')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('celular') }}</div>
          }
        </div>
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('correo')">
          <label class="home-cuenta__label" [for]="idPrefix + '-correo'">Correo electrónico*</label>
          <input
            [id]="idPrefix + '-correo'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('correo')"
            type="email"
            formControlName="correo"
            placeholder="Escribe aquí"
            maxlength="50"
            autocomplete="email"
            (input)="onCorreoInput($event)"
          />
          @if (isInvalidStep1('correo')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('correo') }}</div>
          }
        </div>
      </div>

      <div class="home-cuenta-juridica__row home-cuenta-juridica__row--document">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('tipoDoc')">
          <label class="home-cuenta__label" [for]="idPrefix + '-tipo-doc'">Tipo de doc*</label>
          <select
            [id]="idPrefix + '-tipo-doc'"
            class="home-cuenta__select"
            [class.is-invalid]="isInvalidStep1('tipoDoc')"
            formControlName="tipoDoc"
          >
            <option [value]="''">Selecciona</option>
            @for (doc of documentos; track doc.idTipoDocIdentidad) {
              <option [value]="doc.idTipoDocIdentidad">{{ doc.nombre }}</option>
            }
          </select>
          @if (isInvalidStep1('tipoDoc')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('tipoDoc') }}</div>
          }
        </div>
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('numDoc')">
          <label class="home-cuenta__label" [for]="idPrefix + '-num-doc'">Número documento*</label>
          <input
            [id]="idPrefix + '-num-doc'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('numDoc')"
            type="text"
            formControlName="numDoc"
            placeholder="Escribe aquí"
            maxlength="15"
            autocomplete="off"
            appNumeroDocumentoPorTipo
            [tipos]="documentos"
            idTipoDocControlName="tipoDoc"
          />
          @if (isInvalidStep1('numDoc')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('numDoc') }}</div>
          }
        </div>
        <div
          class="home-cuenta__field"
          [class.home-cuenta__field--invalid]="isInvalidStep1('confirmaDoc') || step1Form.get('confirmaDoc')?.hasError('confirmDocMismatch')"
        >
          <label class="home-cuenta__label" [for]="idPrefix + '-confirma-doc'">Confirma documento*</label>
          <input
            [id]="idPrefix + '-confirma-doc'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep1('confirmaDoc') || step1Form.get('confirmaDoc')?.hasError('confirmDocMismatch')"
            type="text"
            formControlName="confirmaDoc"
            placeholder="Escribe aquí"
            maxlength="15"
            autocomplete="off"
            appNumeroDocumentoPorTipo
            [tipos]="documentos"
            idTipoDocControlName="tipoDoc"
            [allowPaste]="false"
            oncopy="return false"
          />
          @if (step1Form.get('confirmaDoc')?.hasError('confirmDocMismatch') && (step1Form.get('confirmaDoc')?.dirty || step1Form.get('confirmaDoc')?.touched)) {
            <div class="home-cuenta__error">Los números de documento no coinciden</div>
          } @else if (isInvalidStep1('confirmaDoc')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('confirmaDoc') }}</div>
          }
        </div>
      </div>

      <div class="home-cuenta-juridica__row home-cuenta__row--stack-mobile">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep1('password')">
          <label class="home-cuenta__label" [for]="idPrefix + '-password'">Crea tu contraseña*</label>
          <div class="home-cuenta__password-wrap">
            <input
              [id]="idPrefix + '-password'"
              class="home-cuenta__input home-cuenta__input--password"
              [class.is-invalid]="isInvalidStep1('password')"
              [attr.type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Escribe aquí"
              autocomplete="new-password"
              (focus)="onPasswordFocus()"
              (blur)="onPasswordBlur()"
            />
            <button
              type="button"
              class="home-cuenta__password-toggle"
              (mousedown)="$event.preventDefault()"
              (click)="togglePassword()"
              [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
            </button>
          </div>
          @if (isInvalidStep1('password')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('password') }}</div>
          } @else if (passwordFieldActive) {
            <div class="home-cuenta__hint">{{ passwordHint }}</div>
          }
        </div>
        <div
          class="home-cuenta__field"
          [class.home-cuenta__field--invalid]="isInvalidStep1('confirmaPassword') || step1Form.get('confirmaPassword')?.hasError('confirmPasswordMismatch')"
        >
          <label class="home-cuenta__label" [for]="idPrefix + '-confirma-password'">Confirma tu contraseña*</label>
          <div class="home-cuenta__password-wrap">
            <input
              [id]="idPrefix + '-confirma-password'"
              class="home-cuenta__input home-cuenta__input--password"
              [class.is-invalid]="isInvalidStep1('confirmaPassword') || step1Form.get('confirmaPassword')?.hasError('confirmPasswordMismatch')"
              [attr.type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmaPassword"
              placeholder="Escribe aquí"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="home-cuenta__password-toggle"
              (click)="toggleConfirmPassword()"
              [attr.aria-label]="showConfirmPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            >
              <i [class]="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'" aria-hidden="true"></i>
            </button>
          </div>
          @if (step1Form.get('confirmaPassword')?.hasError('confirmPasswordMismatch') && (step1Form.get('confirmaPassword')?.dirty || step1Form.get('confirmaPassword')?.touched)) {
            <div class="home-cuenta__error">Las contraseñas no coinciden</div>
          } @else if (isInvalidStep1('confirmaPassword')) {
            <div class="home-cuenta__error">{{ errorMsgStep1('confirmaPassword') }}</div>
          }
        </div>
      </div>
    </div>

    <button type="button" class="home-cuenta-juridica__continue" (click)="continuar()">
      Continuar registro
    </button>
  </form>

  <form
    class="home-cuenta-juridica home-cuenta-juridica--step-2 home-cuenta__form home-cuenta-juridica__step-pane home-cuenta-juridica__step-pane--2"
    [class.home-cuenta-juridica__step-pane--active]="pasoActual === 2"
    [formGroup]="step2Form"
    novalidate
  >
    <div class="home-cuenta-juridica__step-header">
      <span class="home-cuenta-juridica__step-badge">Paso 2:</span>
      <h3 class="home-cuenta-juridica__step-title">Datos de la empresa</h3>
    </div>

    <div class="home-cuenta-juridica__form">
      <div class="home-cuenta-juridica__row home-cuenta-juridica__row--nit">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep2('nit')">
          <label class="home-cuenta__label" [for]="idPrefix + '-nit'">NIT*</label>
          <input
            [id]="idPrefix + '-nit'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep2('nit')"
            type="text"
            formControlName="nit"
            placeholder="Escribe aquí"
            maxlength="9"
            appOnlyNumbers
          />
          @if (isInvalidStep2('nit')) {
            <div class="home-cuenta__error">{{ errorMsgStep2('nit') }}</div>
          }
        </div>
        <div class="home-cuenta__field">
          <label class="home-cuenta__label" [for]="idPrefix + '-dv'">DV</label>
          <input
            [id]="idPrefix + '-dv'"
            class="home-cuenta__input home-cuenta__input--readonly"
            type="text"
            formControlName="dv"
            maxlength="1"
            tabindex="-1"
            aria-readonly="true"
          />
        </div>
      </div>

      <div
        class="home-cuenta-juridica__row home-cuenta-juridica__row--contacto home-cuenta__row--stack-mobile"
        [class.home-cuenta-juridica__row--contacto-con-cargo]="mostrarCargoOtro"
      >
        <div
          class="home-cuenta__field home-cuenta-juridica__field--persona"
          [class.home-cuenta__field--invalid]="isInvalidStep2('personaDeContacto')"
        >
          <label
            class="home-cuenta__label home-cuenta__label--single-line"
            [for]="idPrefix + '-persona-contacto'"
          >Persona de contacto&nbsp;*</label>
          <select
            [id]="idPrefix + '-persona-contacto'"
            class="home-cuenta__select"
            [class.is-invalid]="isInvalidStep2('personaDeContacto')"
            formControlName="personaDeContacto"
          >
            <option [value]="''">Selecciona una opción</option>
            <option value="Representante legal">Representante legal</option>
            <option value="Gerente">Gerente</option>
            <option value="Otros">Otros</option>
          </select>
          @if (isInvalidStep2('personaDeContacto')) {
            <div class="home-cuenta__error">{{ errorMsgStep2('personaDeContacto') }}</div>
          }
        </div>

        <div
          class="home-cuenta__field home-cuenta-juridica__field--cargo"
          [class.home-cuenta__field--invalid]="isInvalidStep2('tipoPersonaOtro')"
          [attr.hidden]="mostrarCargoOtro ? null : true"
          [attr.aria-hidden]="!mostrarCargoOtro"
        >
          <label
            class="home-cuenta__label home-cuenta__label--single-line"
            [for]="idPrefix + '-cargo'"
          >Cargo&nbsp;*</label>
          <input
            [id]="idPrefix + '-cargo'"
            class="home-cuenta__input"
            [class.is-invalid]="isInvalidStep2('tipoPersonaOtro')"
            type="text"
            formControlName="tipoPersonaOtro"
            placeholder="Digita cargo"
            maxlength="30"
            appOnlyLetters
          />
          @if (isInvalidStep2('tipoPersonaOtro')) {
            <div class="home-cuenta__error">{{ errorMsgStep2('tipoPersonaOtro') }}</div>
          }
        </div>

        <div
          class="home-cuenta__field home-cuenta-juridica__field--contacto"
          [class.home-cuenta__field--invalid]="isInvalidStep2('contacto')"
        >
          <label
            class="home-cuenta__label home-cuenta__label--single-line"
            [for]="idPrefix + '-contacto'"
          >¿Cómo deseas ser contactado?&nbsp;*</label>
          <select
            [id]="idPrefix + '-contacto'"
            class="home-cuenta__select selectpicker"
            [class.is-invalid]="isInvalidStep2('contacto')"
            formControlName="contacto"
            multiple
            data-live-search="true"
            data-size="4"
            data-width="100%"
            data-container="body"
            data-dropup-auto="true"
            data-actions-box="true"
            data-select-all-text="<i class='fas fa-plus'></i> Seleccionar"
            data-deselect-all-text="<i class='fas fa-minus'></i> Quitar todos"
            title="Selecciona una opción"
            (change)="selectpickerChangeContactos()"
          >
            @for (tipo of tiposContacto; track tipo.idTipoContacto) {
              <option [value]="tipo.idTipoContacto">{{ tipo.nombre }}</option>
            }
          </select>
          @if (isInvalidStep2('contacto')) {
            <div class="home-cuenta__error">{{ errorMsgStep2('contacto') }}</div>
          }
        </div>
      </div>

      <div class="home-cuenta-juridica__row home-cuenta-juridica__row--full home-cuenta__row--stack-mobile">
        <div class="home-cuenta__field" [class.home-cuenta__field--invalid]="isInvalidStep2('origen')">
          <label
            class="home-cuenta__label home-cuenta__label--single-line"
            [for]="idPrefix + '-origen'"
          >¿Cómo te enteraste de neocrédito?&nbsp;*</label>
          <select
            [id]="idPrefix + '-origen'"
            class="home-cuenta__select selectpicker"
            [class.is-invalid]="isInvalidStep2('origen')"
            formControlName="origen"
            data-live-search="true"
            data-size="6"
            data-width="100%"
            data-container="body"
            data-dropup-auto="true"
          >
            <!-- hidden: placeholder en el botón sin fila en blanco en el menú (evita bs-title-option vacío) -->
            <option value="" disabled hidden>Selecciona una opción</option>
            @for (fuente of fuentes; track fuente.idFuenteNeocredito) {
              <option [value]="fuente.idFuenteNeocredito">{{ fuente.fuente }}</option>
            }
          </select>
          @if (isInvalidStep2('origen')) {
            <div class="home-cuenta__error">{{ errorMsgStep2('origen') }}</div>
          }
        </div>
      </div>
    </div>

    <app-home-cuenta-form-footer
      #footer
      class="home-cuenta-form-footer--juridica"
      [idPrefix]="idPrefix"
      [fieldsComplete]="registroCompleto"
      [showBackLink]="true"
      (back)="volver()"
      (submit)="onSubmit()"
    ></app-home-cuenta-form-footer>
  </form>
</div>
